export const PLACEMENT = {
  LEFT: 'left',
  LEFT_TOP: 'left top',
  LEFT_BOTTOM: 'left bottom',
  RIGHT: 'right',
  RIGHT_TOP: 'right top',
  RIGHT_BOTTOM: 'right bottom',
  TOP: 'top',
  TOP_LEFT: 'top left',
  TOP_RIGHT: 'top right',
  BOTTOM: 'bottom',
  BOTTOM_LEFT: 'bottom left',
  BOTTOM_RIGHT: 'bottom right'
};